import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  Layers, ClipboardList, TrendingUp, Bell, 
  Lock, Globe, ArrowRight, ArrowLeft
} from 'lucide-react';
import { motion } from 'framer-motion';

interface HighlightsProps {
  onNext: () => void;
  onBack: () => void;
}

const HIGHLIGHTS = [
  {
    icon: Layers,
    title: 'Gestão de Contratos',
    desc: 'Organize por clusters regionais, acompanhe prazos e documentação.',
  },
  {
    icon: ClipboardList,
    title: 'Medições e Entregas',
    desc: 'Boletins de medição, itens executados e avanço físico-financeiro.',
  },
  {
    icon: TrendingUp,
    title: 'Indicadores de Performance',
    desc: 'Dashboards consolidados de progresso, desvios e tendências.',
  },
  {
    icon: Bell,
    title: 'Alertas Inteligentes',
    desc: 'Notificações sobre prazos, Quality Gate e medições pendentes.',
  },
  {
    icon: Lock,
    title: 'Segurança e Governança',
    desc: 'Controle por perfil, isolamento de dados e trilha de auditoria.',
  },
  {
    icon: Globe,
    title: 'Colaboração Multi-stakeholder',
    desc: 'Construtoras, contratantes e financiadores em uma plataforma.',
  },
];

const item = {
  hidden: { opacity: 0, y: 10 },
  show: { opacity: 1, y: 0 },
};

export const OnboardingHighlights: React.FC<HighlightsProps> = ({ onNext, onBack }) => (
  <motion.div
    className="space-y-5"
    initial="hidden"
    animate="show"
    variants={{ show: { transition: { staggerChildren: 0.05 } } }}
  >
    <motion.div variants={item}>
      <h2 className="text-xl font-semibold">Conheça o NetUno</h2>
      <p className="text-sm text-muted-foreground mt-1">
        Principais capacidades da plataforma.
      </p>
    </motion.div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
      {HIGHLIGHTS.map(({ icon: Icon, title, desc }) => (
        <motion.div
          key={title}
          variants={item}
          className="flex items-start gap-3 p-3 rounded-xl border border-border/60 bg-card hover:bg-primary/[0.03] hover:border-primary/20 transition-all duration-200"
        >
          <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon className="w-4 h-4 text-primary" />
          </div>
          <div className="min-w-0">
            <p className="text-[13px] font-medium">{title}</p>
            <p className="text-xs text-muted-foreground leading-relaxed mt-0.5">{desc}</p>
          </div>
        </motion.div>
      ))}
    </div>

    <motion.div variants={item} className="flex gap-3">
      <Button variant="outline" onClick={onBack} className="flex-1 group">
        <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" />
        Voltar
      </Button>
      <Button onClick={onNext} className="flex-1 group">
        Próximo
        <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
      </Button>
    </motion.div>
  </motion.div>
);
